import { z } from "zod";

// Mesmas opções da /parceiros — bate com property `cartera_externo` no HubSpot.
export const CARTEIRA_OPTIONS = [
  { value: "ate1milhao", label: "Até R$ 1 milhão" },
  { value: "1a5milhoes", label: "R$ 1 a 5 milhões" },
  { value: "5a20milhoes", label: "R$ 5 a 20 milhões" },
  { value: "20a100milhoes", label: "R$ 20 a 100 milhões" },
  { value: "acima100milhoes", label: "Mais de R$ 100 milhões" },
] as const;

// Form da /selecao = 4 campos. SEM lgpd_consent (decisão do user).
export const selecaoFormSchema = z.object({
  fullname: z
    .string()
    .min(3, "Informe seu nome completo")
    .refine((v) => v.trim().includes(" "), {
      message: "Informe nome e sobrenome",
    }),
  email: z.string().email("E-mail inválido"),
  phone: z
    .string()
    .min(14, "Telefone com DDD: (XX) XXXXX-XXXX"),
  carteira_size: z.string().min(1, "Selecione uma faixa"),
});

export type SelecaoFormData = z.infer<typeof selecaoFormSchema>;
